import { UiAddToSlackSectionModel } from "../../models";
import { mockDocument } from "../adf";

export function mockUiAddToSlackSectionModel({
    id = "some-ui-add-to-slack-section-id",
    locale = "en",
    content = {
        entryTitle: "Add to Slack section",
        buttonText: mockDocument(),
        loginText: mockDocument(),
        selectTeamText: mockDocument(),
        noTeamText: mockDocument()
    }
}: Partial<
    Omit<UiAddToSlackSectionModel, "type">
> = {}): UiAddToSlackSectionModel {
    return {
        id,
        type: "uiAddToSlackSection",
        locale,
        content
    };
}
